/**
 * גרסת הנתונים. כל האוספים הראשיים מתחילים ב-"v2_", כדי שהמערכת תוכל לשבת באותו פרויקט Firebase
 * לצד נתונים ישנים בלי להתנגש בהם. תתי-אוספים (registrations, messages וכו') נמצאים ממילא בתוך מסמכי v2_.
 */
export const DATA_PREFIX = 'v2_';

/** שמות האוספים ב-Firestore. שימוש בקבועים מונע שגיאות כתיב בין web ל-worker. */
export const COLLECTIONS = {
  admins: 'v2_admins',
  /** תת-אוסף של מנהל */
  adminDevices: 'devices',
  jobs: 'v2_jobs',
  /** תת-אוסף של עבודה */
  jobSecrets: 'secrets',
  /** תת-אוסף של עבודה */
  registrations: 'registrations',
  contractors: 'v2_contractors',
  /** טלפון → מזהה במאגר, אחרי שמספר של מישהו נערך. השרת בלבד. */
  phoneIds: 'v2_phoneIds',
  personalTokens: 'v2_personalTokens',
  /** מיפוי מזהה ציבורי של קישור הרשמה → עבודה. השרת בלבד. */
  registrationSlugs: 'v2_registrationSlugs',
  /** עדכונים מהמנהל לנרשמים — תת-אוסף של עבודה */
  announcements: 'announcements',
  /** שיחה פרטית בין המנהלים לנרשם בעבודה; מזהה = `${jobId}__${contractorId}` */
  threads: 'v2_threads',
  /** תת-אוסף של שיחה */
  messages: 'messages',
  /** צ'אט פנימי של המנהלים */
  teamChat: 'v2_teamChat',
  changeRequests: 'v2_changeRequests',
  activityLog: 'v2_activityLog',
  notifications: 'v2_notifications',
  /** הגדרות ומצב מערכת: v2_config/settings, v2_config/status */
  config: 'v2_config',
  /** יומן תקלות — השרת בלבד, המפתח קורא דרך השרת */
  errorLog: 'v2_errorLog',
} as const;

export const CONFIG_DOCS = { settings: 'settings', status: 'status' } as const;

/** מזהה המסמך היחיד בתת-האוסף secrets של עבודה. */
export const JOB_ACCESS_SECRET_DOC = 'access';

/**
 * תקרה מוחלטת למספר המנהלים הפעילים (הגנה). המספר בפועל נקבע ע"י המפתח
 * בהגדרות המערכת (maxAdmins), בין 1 לתקרה הזו.
 */
export const MAX_ADMINS = 50;

export const APP_TIME_ZONE = 'Asia/Jerusalem';

export const LIMITS = {
  accessCodeLength: 6,
  /** אורך האסימון האישי בבתים (256 ביט). */
  personalTokenBytes: 32,
  /** אורך מזהה ההרשמה הציבורי בתווים. */
  registrationSlugLength: 10,
  minWorkers: 1,
  maxWorkers: 500,
  maxNameLength: 80,
  maxJobNameLength: 120,
  maxLocationLength: 200,
  maxNotesLength: 2000,
  maxRequestNoteLength: 300,
  maxAnnouncementLength: 1000,
  maxMessageLength: 1000,
} as const;

/** מדיניות הגבלת ניסיונות לקוד כניסה. */
export const ACCESS_CODE_RATE_LIMIT = {
  /** מספר ניסיונות שגויים מותר בחלון הזמן לפני נעילה. */
  maxFailures: 5,
  windowMs: 15 * 60 * 1000,
  /** נעילה ראשונה; כל נעילה נוספת מכפילה את הזמן, עד המקסימום. */
  baseLockMs: 15 * 60 * 1000,
  maxLockMs: 24 * 60 * 60 * 1000,
} as const;
